import React, { cloneElement, type JSX } from "react";
import { twMerge } from "tailwind-merge";

import type { CommonColors } from "../../../../types/colors";

interface BadgeLabelProps {
  color?: CommonColors;
  className?: string;
  icon?: JSX.Element;
  small?: boolean;
  invisible?: boolean;
}

const STYLES = {
  default: "bg-neutral-50 text-neutral-600 border-0.5 border-neutral-600",
  primary: "bg-neutral-600 text-neutral-50",
  warning: "bg-warning-600 text-neutral-50",
  info: "bg-info-500 text-neutral-900",
  success: "bg-success-600 text-neutral-50",
  error: "bg-error-700 text-neutral-50",
} as const;

export const IconBadge = ({ color = "primary", className, icon, small = false, invisible = false }: BadgeLabelProps) =>
  icon ? (
    <span
      className={twMerge(
        "inline-flex justify-center items-center transition-opacity",
        STYLES[color],
        small ? "w-3 h-3" : "w-5 h-5",
        invisible ? "invisible opacity-0" : "visible opacity-100",
        className
      )}
    >
      {cloneElement(icon, { className: small ? "w-3 h-3" : "w-5 h-5" })}
    </span>
  ) : null;
